import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import { notification } from "antd";
import useStateRef from "react-usestateref";
import { HiOutlineLockClosed, HiOutlineEye, HiOutlineEyeOff, HiOutlineArrowLeft, HiOutlineShieldCheck } from 'react-icons/hi';

function ResetPasswordComponent() {
    const { uuid } = useParams();
    let Var_History = useHistory();

    const [Var_Email, setVar_Email] = useState("");
    const [Var_Password, setVar_Password, Var_Password_Ref] = useStateRef("");
    const [Var_UserId, setVar_UserId] = useState("");
    const [Var_UuId, setVar_UuId, Var_UuId_Ref] = useStateRef("");
    const [Var_ConfirmPassword, setVar_ConfirmPassword, Var_ConfirmPassword_Ref] = useStateRef("");
    const [Var_ConfirmPasswordError, setVar_ConfirmPasswordError] = useState(false);
    const [Var_PasswordError, setVar_PasswordError] = useState(false);
    const [Var_PasswordMatchError, setVar_PasswordMatchError] = useState(false);
    const [Var_Hidden, setVar_Hidden] = useState(true);
    const [Var_HiddenPassword, setVar_HiddenPassword] = useState(true);
    const [loading, setLoading] = useState(false);
    const [Uuid_Load, setUuid_Load] = useState(false);

    useEffect(() => {
        if (uuid && !Var_UuId_Ref.current) {
            setVar_UuId(uuid);
        }
    }, [uuid]);

    useEffect(() => {
        if (Var_UuId_Ref.current && Uuid_Load === false) {
            validateUuid();
            setUuid_Load(true);
        }
    }, [Var_UuId_Ref.current, Uuid_Load]);

    const resetPassword = () => {
        Var_History.push("/forgot");
    };
    const navigateLogin = () => {
        Var_History.push("/");
    };

    const toggleshow = () => {
        setVar_Hidden(!Var_Hidden);
    };
    const toggleshowpassword = () => {
        setVar_HiddenPassword(!Var_HiddenPassword);
    };

    const validateUuid = async () => {
        try {
            setLoading(true);
            const host = window.location.host;
            const pathName = window.location.pathname.split("/")[1] || "";
            const dataObj = {
                uuid: Var_UuId_Ref.current,
                host,
                pathname: pathName,
            };

            const response = await axiosInstance.post("doctor/validate_uuid", dataObj);

            if (response.data.status === 1) {
                setVar_Email(response.data.data[0].email);
                setVar_UserId(response.data.data[0].user_id);
            } else {
                notification.error({
                    message: response.data.msg,
                });
                resetPassword();
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const checkValidation = () => {
        if (!Var_Password_Ref.current) {
            setVar_PasswordError(true);
        } else if (!Var_ConfirmPassword_Ref.current) {
            setVar_PasswordError(false);
            setVar_ConfirmPasswordError(true);
        } else if (Var_Password_Ref.current !== Var_ConfirmPassword_Ref.current) {
            setVar_PasswordError(false);
            setVar_ConfirmPasswordError(false);
            setVar_PasswordMatchError(true);
        } else {
            setVar_PasswordError(false);
            setVar_ConfirmPasswordError(false);
            setVar_PasswordMatchError(false);
            submitPassword();
        }
    };

    const submitPassword = async () => {
        try {
            setLoading(true);
            const host = window.location.host;
            const pathName = window.location.pathname.split("/")[1] || "";
            const dataObj = {
                email: Var_Email,
                uuid: Var_UuId_Ref.current,
                password: Var_Password_Ref.current,
                user_id: Var_UserId,
                host,
                pathname: pathName,
            };

            const response = await axiosInstance.post("doctor/check_nd_reset_password", dataObj);

            if (response.data.status === 1) {
                notification.success({
                    message: response.data.msg,
                });
                navigateLogin();
            } else {
                notification.error({
                    message: response.data.msg,
                });
                resetPassword();
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4 font-sans">
            <div className="max-w-md w-full bg-white rounded-3xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.15)] overflow-hidden flex flex-col p-8 sm:p-10 relative">

                {/* Back to Login Button */}
                <button
                    onClick={navigateLogin}
                    className="absolute top-8 left-8 text-gray-400 hover:text-teal-600 transition-colors flex items-center gap-1.5 text-sm font-medium border-none bg-transparent cursor-pointer"
                >
                    <HiOutlineArrowLeft /> Back
                </button>

                <div className="flex flex-col items-center mt-6">
                    <div className="w-16 h-16 bg-teal-50 text-teal-600 rounded-2xl flex items-center justify-center mb-6 shadow-sm border border-teal-100">
                        <HiOutlineShieldCheck size={28} />
                    </div>

                    <div className="mb-8 text-center">
                        <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">Reset Password</h1>
                        <p className="text-sm text-gray-500">Secure your account by entering a new password</p>
                    </div>

                    <div className="w-full space-y-5">
                        {/* New Password Field */}
                        <div>
                            <label className="block text-xs font-semibold text-gray-700 mb-1.5 uppercase tracking-wider">New Password</label>
                            <div className="relative group">
                                <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-gray-400 group-focus-within:text-teal-600 transition-colors">
                                    <HiOutlineLockClosed className="h-5 w-5" />
                                </div>
                                <input
                                    type={Var_Hidden ? "password" : "text"}
                                    className={`block w-full pl-10 pr-12 py-3 border-2 ${Var_PasswordError ? 'border-red-500' : 'border-gray-100'} rounded-xl focus:ring-4 focus:ring-teal-500/10 focus:border-teal-500 transition-all outline-none text-gray-800 bg-white placeholder:text-gray-400 text-sm`}
                                    placeholder="Enter your password"
                                    value={Var_Password}
                                    onChange={(e) => setVar_Password(e.target.value)}
                                />
                                <button
                                    type="button"
                                    className="absolute inset-y-0 right-0 pr-3.5 flex items-center text-gray-400 hover:text-teal-600 transition-colors border-none bg-transparent cursor-pointer"
                                    onClick={toggleshow}
                                >
                                    {Var_Hidden ? <HiOutlineEyeOff size={18} /> : <HiOutlineEye size={18} />}
                                </button>
                            </div>
                            {Var_PasswordError && <p className="mt-1.5 text-xs text-red-500 font-semibold ml-1">Please enter password</p>}
                        </div>

                        {/* Confirm Password Field */}
                        <div>
                            <label className="block text-xs font-semibold text-gray-700 mb-1.5 uppercase tracking-wider">Confirm Password</label>
                            <div className="relative group">
                                <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-gray-400 group-focus-within:text-teal-600 transition-colors">
                                    <HiOutlineLockClosed className="h-5 w-5" />
                                </div>
                                <input
                                    type={Var_HiddenPassword ? "password" : "text"}
                                    className={`block w-full pl-10 pr-12 py-3 border-2 ${Var_ConfirmPasswordError || Var_PasswordMatchError ? 'border-red-500' : 'border-gray-100'} rounded-xl focus:ring-4 focus:ring-teal-500/10 focus:border-teal-500 transition-all outline-none text-gray-800 bg-white placeholder:text-gray-400 text-sm`}
                                    placeholder="Enter your confirm password"
                                    value={Var_ConfirmPassword}
                                    onChange={(e) => setVar_ConfirmPassword(e.target.value)}
                                />
                                <button
                                    type="button"
                                    className="absolute inset-y-0 right-0 pr-3.5 flex items-center text-gray-400 hover:text-teal-600 transition-colors border-none bg-transparent cursor-pointer"
                                    onClick={toggleshowpassword}
                                >
                                    {Var_HiddenPassword ? <HiOutlineEyeOff size={18} /> : <HiOutlineEye size={18} />}
                                </button>
                            </div>
                            {Var_ConfirmPasswordError && <p className="mt-1.5 text-xs text-red-500 font-semibold ml-1">Please enter confirm password</p>}
                            {Var_PasswordMatchError && <p className="mt-1.5 text-xs text-red-500 font-semibold ml-1">Passwords do not match</p>}
                        </div>

                        {/* Action Buttons */}
                        <div className="pt-2 space-y-3">
                            <button
                                onClick={checkValidation}
                                disabled={loading}
                                className={`w-full py-3.5 px-6 rounded-xl text-white font-bold text-base shadow-lg transform transition-all active:scale-[0.98] border-none cursor-pointer ${loading
                                    ? 'bg-gray-400 cursor-not-allowed'
                                    : 'bg-gradient-to-r from-teal-600 to-teal-700 hover:from-teal-700 hover:to-teal-800 hover:shadow-teal-100 shadow-teal-500/30 hover:-translate-y-0.5'
                                    }`}
                            >
                                {loading ? (
                                    <span className="flex items-center justify-center">
                                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                        Updating...
                                    </span>
                                ) : "Update Password"}
                            </button>

                            <button
                                onClick={navigateLogin}
                                className="w-full py-3 px-6 rounded-xl text-gray-500 font-semibold text-sm hover:bg-gray-50 transition-colors text-center border-none bg-transparent cursor-pointer"
                            >
                                Cancel
                            </button>
                        </div>

                        <p className="mt-8 text-center text-xs sm:text-sm text-gray-500">
                            Having trouble? <span className="text-teal-600 font-semibold cursor-pointer">Contact Tech Support</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ResetPasswordComponent;
